export const settingsInitial = Object.freeze({
  enabled: false,
  pushEnabled: true,
  activityPushEnabled: false,
  userAmended: null,
  userAmendedName: null,
  dateAmended: null,
});

export default Object.freeze({
  data: settingsInitial,
  loading: false,
  saving: false,
  loaded: false,
});
